import { Container, Flex } from '@chakra-ui/react';

import { NavBarLogo, NavBarMenu } from '@components/Navbar/NavBar';

import { ContainerMaxW } from '../../layouts/EventLayout';

const NavSection = () => {
  return (
    <Flex w="full">
      <Container maxW={ContainerMaxW}>
        <Flex justifyContent="space-between" height="80px" alignItems="center">
          <NavBarLogo />
          <NavBarMenu />
        </Flex>
      </Container>
    </Flex>
  );
};

export default NavSection;
